// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"K8-z","upvote":"L8-z","downvote":"M8-z","numVotes":"N8-z","votesDescription":"O8-z","report":"P8-z","voted":"Q8-z","answerVoteBox":"R8-z","justReported":"S8-z"};